<ng-container *ngIf="isUkShfyInstance$ | async; else originalForgotPasswordPage">
  <app-dxp-send-forgot-password data-test-id="send-forgot-password-dxp-send-forgot-password" ></app-dxp-send-forgot-password>
</ng-container>

<ng-template #originalForgotPasswordPage>
  <ng-container *transloco="let t; read: 'sendForgotPassword'">
    <div data-test-id="send-forgot-password-main-container"  class="main-container">
      <div data-test-id="send-forgot-password-card-x"  class="cardx shadow-sm">
        
        @if (isUkDfp$|async) {
          <img data-test-id="send-forgot-password-logo" class="ukdfp logo tw-h-16 tw-w-16" src="/assets/img/ukdfplogo.png" alt="ukdfp logo" />
        } @else {
          <img data-test-id="send-forgot-password-logo" class="logo" src="/assets/img/synlab-logo.svg" alt="SYNLAB logo" />
        }
        
        <p data-test-id="send-forgot-password-title">
          {{ (isUkDfp$|async) ? t("heading2") : t("heading") }}
        </p>
        <form data-test-id="send-forgot-password-email-entry-form"  [formGroup]="form" (submit)="onSubmit()" id="emailEntryForm">
          <div data-test-id="send-forgot-password-email-input-wrapper"  class="email-input">
            <input data-test-id="send-forgot-password-email-control" 
              formControlName="email"
              type="text"
              class="form-control-lg form-control"
              [placeholder]="t('email')"
              [ngClass]="{ 'is-invalid': form.invalid && form.touched }"
            />
            <span data-test-id="send-forgot-password-on-clear-btn"  id="clearInputTrigger" *ngIf="email.value" role="button" (click)="onClear('email')">
              <em data-test-id="send-forgot-password-on-clear-icon"  class="fa fa-times"></em>
            </span>
          </div>

          <div data-test-id="send-forgot-password-action-btn"  class="action-buttons pt-2">
            <button data-test-id="send-forgot-password-on-cancel-btn"  id="cancelButton" class="btn btn-light" type="button" (click)="onCancel()">
              {{ t("cancel") }}
            </button>
            <button data-test-id="send-forgot-password-proceed-btn"  class="btn btn-primary" type="submit" [disabled]="form.invalid || loading || submitted">
              @if (isYellowIndigoUI$|async) {
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4.66797 10H16.3346" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M10.5 4.16602L16.3333 9.99935L10.5 15.8327" stroke="#0077AD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>
              }
              {{ t("proceed") }}
            </button>
          </div>
        </form>
      </div>
      <div data-test-id="send-forgot-password-alert-success" 
        *ngIf="message && submitted"
        class="alert alert-success"
        [innerHTML]="t(message, { email: email.value })"
      ></div>
      <div data-test-id="send-forgot-password-alert-danger"  *ngIf="isUserDeactivated && submitted" class="alert alert-danger" [innerHTML]="deactivatedMessage"></div>
    </div>
    @if (!(isYellowIndigoUI$|async)) {
      <div data-test-id="send-forgot-password-bg-img"  class="bg-image"></div>
    }
    
  </ng-container>
</ng-template>
